import React from 'react'

interface Props {
    x: number
    y: number
    r: number
    fill?: string
    fillOpacity?: number
    stroke?: string
    strokeWidth?: number,
    cursor?: 'pointer' | 'auto'
    dataOrg?: string
    dataStage?: string,
    dataID?: string,
    onClick?: any,
    children?: React.ReactNode
}


const D3Circle: React.FC<Props> = ({x, y, r, fill, fillOpacity, stroke, strokeWidth, dataID, dataOrg, dataStage, onClick, cursor, children}) => {
    return (
       <circle className='ccircle'
            cx={x} cy={y} r={r}
            fill={fill || `black`}
            fillOpacity={fillOpacity || 1}
            cursor={cursor || 'auto'}
            stroke={stroke || `transparent`}
            strokeWidth={strokeWidth || 0}
            data-org={dataOrg}
            data-stage={dataStage}
            data-id={dataID}
            onClick={onClick}
            children={children}
        />
    )
}

export default D3Circle
